import React, { Component, createElement, Fragment } from 'react';
import { Button } from '@comall-backend-builder/components-basis';
import { ComponentsManager } from '@comall-backend-builder/core';
import { isNull } from 'lodash';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { ICategoryTree } from '../../interfaces';

interface Props {
    componentId: string;
    entities: { [index: string]: Entity };
}

interface States {
    currentViewCategory: ICategoryTree | null;
}

function findCategoryById(listItem: ICategoryTree[], id: number) {
    let result: ICategoryTree | null = null;
    listItem.some(function finder(item) {
        if (item.id == id) {
            result = item;
            return true;
        }
        if (item.childrenNode && item.childrenNode.length > 0) {
            return item.childrenNode.some(finder);
        }
    });
    return result;
}

export class CategoryCombineList extends Component<Props, States> {
    constructor(props: Props) {
        super(props);
        this.state = { currentViewCategory: null };
        this.onSwitchCategory = this.onSwitchCategory.bind(this);
    }

    onSwitchCategory(id: number) {
        const {
            entities: { categoryTree, categoryList },
            componentId,
        } = this.props;
        categoryList.filtersChange({
            displayCategoryId: id,
        } as any);
        categoryList.search({
            ...categoryList.params,
            ...categoryList.filters,
        });

        this.setState({
            currentViewCategory: findCategoryById(categoryTree.fields as ICategoryTree[], id),
        });
    }

    renderTree() {
        const {
            entities: { categoryTree },
            componentId,
        } = this.props;
        const treeProps = {
            entity: categoryTree,
            componentId: componentId + '-Tree',
            onSelect: this.onSwitchCategory,
        };
        return createElement(ComponentsManager.get('CategoryLinkageTree'), treeProps);
    }

    renderTable() {
        const {
            entities: { categoryList, categoryTree },
            componentId,
        } = this.props;
        const { currentViewCategory } = this.state;

        let defaultLive: any = 0;
        if (currentViewCategory && currentViewCategory.level) {
            defaultLive = currentViewCategory.level;
        }

        const firstFloorColumns = [
            {
                title: '导航名称',
                property: 'name',
            },
            {
                property: 'sequence',
            },

            {
                property: 'status',
            },
        ];
        const secondFloorColumns = [
            {
                property: 'name',
            },
            {
                property: 'sequence',
            },
            {
                property: 'imgType',
            },
            {
                property: 'status',
            },
        ];
        const thirdlyFloorColumns = [
            {
                title: '展示图名称',
                property: 'name',
            },
            {
                property: 'imgApp',
                displayConfig: {
                    style: {
                        height: 50,
                    },
                    preview: {
                        visible: true,
                        size: 400,
                        placement: 'right',
                    },
                },
            },

            {
                property: 'sequence',
            },
            {
                property: 'imgType',
            },
            {
                property: 'status',
            },
        ];
        const tableProps = {
            entity: categoryList,
            componentId: componentId + '-List',
            rowKey: 'id',
            // loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            columns:
                defaultLive === 1
                    ? secondFloorColumns
                    : defaultLive === 2
                    ? thirdlyFloorColumns
                    : firstFloorColumns,
            actionColumn: {
                title: '操作',
                width: 230,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'link',
                        text: defaultLive === 0 ? '编辑' : '配置',
                        path:
                            defaultLive === 0
                                ? '/product/category/editMenu/{{row.id}}/{{row.level}}'
                                : '/product/category/edit/{{row.id}}/{{row.level}}',
                    },
                    {
                        type: 'component',
                        component: 'CategoryDeleteButton',
                        config: {
                            categoryTreeEntity: categoryTree,
                        },
                    },
                    // {
                    //     type: 'component',
                    //     component: 'CategoryRefreshButton',
                    // },
                ],
            },
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    renderController() {
        const { currentViewCategory } = this.state;
        return (
            <div className="category-combine-list-table-controller">
                {!isNull(currentViewCategory) ? (
                    <Fragment>
                        <div className="category-info">{currentViewCategory.name}:</div>
                        <div className="category-controller-buttons">
                            {currentViewCategory.level === 1 ? (
                                <Button
                                    className="add-category-button"
                                    text="新增同级分类"
                                    type="primary"
                                    icon="plus"
                                    route={`/product/category/addMenu/${currentViewCategory.parentId}`}
                                ></Button>
                            ) : null}

                            {currentViewCategory.level === 1 || currentViewCategory.level === 2 ? (
                                <Button
                                    className="add-category-button"
                                    text="新增子级分类"
                                    type="primary"
                                    icon="plus"
                                    route={
                                        currentViewCategory.level === 1
                                            ? `/product/category/addClass/${currentViewCategory.id}`
                                            : `/product/category/add/${currentViewCategory.id}`
                                    }
                                ></Button>
                            ) : null}

                            {currentViewCategory.level === 0 ? (
                                <Button
                                    className="add-category-button"
                                    text="新增导航"
                                    type="primary"
                                    icon="plus"
                                    route={`/product/category/addMenu/${currentViewCategory.id}`}
                                ></Button>
                            ) : null}
                        </div>
                    </Fragment>
                ) : null}
            </div>
        );
    }

    render() {
        return (
            <div className="category-combine-list">
                <div className="category-combine-list-tree">{this.renderTree()}</div>
                <div className="category-combine-list-table">
                    {this.renderController()}
                    {this.renderTable()}
                </div>
            </div>
        );
    }
}
